// Classes.
import { BaseLocator } from './../locators/base.locator';



export class CompetitionLevelsLocator extends BaseLocator {

    constructor() {
        super('competitionLevelsList');
    }
}

